import React, { useState, useEffect } from "react";
import { Button, TextField, InputAdornment } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/authContext";
import { toast } from "react-toastify";
import logo from "../assets/Logo_Sevenly.png";
import background from "../assets/background.png";
import loaderGif from "../assets/sevenly-loader.gif";
import Axios from "../axios";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import Avatar from "@mui/material/Avatar";
import { grey } from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const Login = () => {
  const { login, navData } = useAuth();
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoder] = useState(false);
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "username") {
      setUsername(value);
    } else if (name === "password") {
      setPassword(value);
    }
  };
  const handleClear = () => {
    setPassword("");
    setUsername("");
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (userName === "") {
      toast.error(" User  is required");
      return;
    }

    if (password === "") {
      toast.error("Password is required");
      return;
    }
    let data = {
      email: userName,
      password: password,
    };

    Axios
      .post(process.env.REACT_APP_BACKEND + "admin-login", data)
      .then(async (response) => {
        let userobj = response.data.admin;
        await login(userobj);
        toast.success(response.data.message);

        if (navData.length === 0) {
          setLoder(true);
        } else {
          navigate(navData[0].link);
        }

        handleClear();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
        handleClear();
      });
  };
  useEffect(() => {
    // Check if navData is populated, then stop the loader and navigate
    if (navData.length > 0) {
      setLoder(false);
      navigate(navData[0].link);
    }
  }, [navData, navigate]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin(e);
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div
      className="container-fluid"
      style={{
        width: "100vw",
        height: "100vh",
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      {loader ? (
        <div className="position-absolute top-50 start-50 translate-middle ">
          <img src={loaderGif} alt="Description of the GIF" />
        </div>
      ) : (
        <>
          <div
            className="position-absolute top-50 start-50 translate-middle bg-white p-4 rounded shadow login_box sevenlycard"
            component="form"
            role="form"
            onSubmit={handleLogin}
          >
            <div className="log_form col-lg-12">
              <div className="d-flex justify-content-center align-items-center  col-lg-6">
                <Avatar
                  sx={{ bgcolor: grey[200], width: 250, height: 250 }}
                  className="mx-4"
                >
                  <img src={logo} className="login_logo" alt="logo" />
                </Avatar>
              </div>
              <div className="mt-2 mx-4 flex justify-content-center align-items-center col-lg-6 p-5">
                <h1 className="sevenly-cursor"> — </h1>
                <h1 className="mb-4 mt-2">Login to your account</h1>
                <TextField
                  label="Email ID"
                  fullWidth
                  variant="standard"
                  className="mt-5"
                  value={userName}
                  onChange={handleChange}
                  name="username"
                  placeholder="example@sevenly.com"
                  onKeyDown={handleKeyDown}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  value={password}
                  variant="standard"
                  className="mt-5"
                  onChange={handleChange}
                  name="password"
                  placeholder="********"
                  onKeyDown={handleKeyDown}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={togglePasswordVisibility}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <div className="text-center mt-5">
                  <Button
                    type="submit"
                    variant="contained"
                    className="w40 fs-12 sevenly-btn"
                    onClick={handleLogin}
                  >
                    Login
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Login;
